import { CKEditor } from "@ckeditor/ckeditor5-react";
import { DecoupledEditor } from "ckeditor5";
import "ckeditor5/ckeditor5.css";
import { useEffect, useRef, useState } from "react";
import "./CKEditor.css";
import { editorConfig } from "./config";
import { uploadApi } from "../../api/uploadApi";
import { message } from "antd";

export function CKEditorComponent({ value, onChange, disabled = false }) {
  const editorContainerRef = useRef(null);
  const editorMenuBarRef = useRef(null);
  const editorToolbarRef = useRef(null);
  const editorRef = useRef(null);
  const [isLayoutReady, setIsLayoutReady] = useState(false);

  useEffect(() => {
    setIsLayoutReady(true);
    return () => setIsLayoutReady(false);
  }, []);

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          loader.file
            .then((file) => {
              const formData = new FormData();
              formData.append("upload", file);
              message.warning("Đang tải hình vui lòng đợi...");
              uploadApi
                .upload(formData)
                .then((res) => {
                  if (res) {
                    console.log("res", res);
                    resolve({
                      default: res.imageUrl,
                    });
                    message.success("Tải hình thành công!");
                  }
                })
                .catch(reject);
            })
            .catch(reject);
        });
      },
    };
  }

  function uploadAdapterPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  return (
    <div className="main-container">
      <div
        className="editor-container editor-container_document-editor editor-container_include-style"
        ref={editorContainerRef}
      >
        <div className="editor-container__menu-bar" ref={editorMenuBarRef} />

        <div className="editor-container__toolbar" ref={editorToolbarRef} />
        <div className="editor-container__editor-wrapper">
          <div className="editor-container__editor">
            <div ref={editorRef}>
              {isLayoutReady && (
                <CKEditor
                  disabled={disabled}
                  onReady={(editor) => {
                    editorToolbarRef.current?.appendChild(
                      editor.ui.view.toolbar.element
                    );
                    editorMenuBarRef.current?.appendChild(
                      editor.ui.view.menuBarView.element
                    );
                  }}
                  onAfterDestroy={() => {
                    Array.from(
                      editorToolbarRef.current?.children || []
                    ).forEach((child) => child.remove());
                    Array.from(
                      editorMenuBarRef.current?.children || []
                    ).forEach((child) => child.remove());
                  }}
                  editor={DecoupledEditor}
                  config={{
                    ...editorConfig,
                    extraPlugins: [uploadAdapterPlugin],
                  }}
                  data={value || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();

                    onChange?.(data);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
